import { useNavigate } from 'react-router-dom'

import { ActionItem, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { convertHoursToTimeFormat } from 'modules/core/lib/formatTime'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import DateRange from 'modules/timeoff/components/DateRange'
import {
  leaveEmployee,
  leaveIsHourly,
  leaveTotalDaysOrHours,
  leaveUnits,
} from 'modules/timeoff/lib/leaveEmployees'
import type LeaveModel from 'modules/timeoff/store/models/Leave'

import styles from '../index.module.scss'

interface Props {
  leave: LeaveModel
}

const LeaveItem = (props: Props) => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { leave } = props

  const onClickEdit = () => {
    const employee = leaveEmployee(leave)
    const myRoute = navigation.timeOff.leavesEditLeaveId.fullPath({ leave_id: leave.attributes.id })

    const anotherRoute = navigation.employees.id.timeOff.leavesEditLeaveId.fullPath({
      id: employee.id,
      leave_id: leave.id,
    })

    navigate(users.current.employee === employee ? myRoute : anotherRoute)
  }

  const halfDayCopy = (): string => {
    const firstHalf = leave.isHalfDayBeginningOfDay()

    return firstHalf
      ? i18n.t('time_off.half_day_item.beggining_of_day')
      : i18n.t('time_off.half_day_item.end_of_day')
  }

  const getYears = () => {
    const years = Object.keys(leaveUnits(leave) ?? {})

    if (!years.length) return
    if (years.length < 2) return years[0]

    const yearEnd = years[years.length - 1]?.slice(2)

    return `${years[0]}/${yearEnd}`
  }

  const years = getYears()

  const getNumberOfUnits = () => {
    const total = leaveTotalDaysOrHours(leave)

    if (!leaveIsHourly(leave) && leave.attributes.half_day && total === 0.5) {
      return halfDayCopy()
    }

    const copy = leaveIsHourly(leave)
      ? buildCopyLeaveInHours(total)
      : `${i18n.tp('time_off.days_with_years', {
          count: total,
        })} (${years})`

    return copy
  }

  const buildCopyLeaveInHours = (total: number) => {
    return convertHoursToTimeFormat(total, true)
  }

  const frenchCalendarFlag = () => {
    return leave.frenchCalendarFlagEnabled() && leave.isPending()
  }

  const title = leave.leaveType?.name
  const isOpen = !leave.attributes.finish_on

  return (
    <ActionItem onClick={onClickEdit} showIcon={false}>
      <div className={styles.leave}>
        <DateRange leave={leave} disabled={isOpen} />
        <div className={styles.body}>
          {title && (
            <div className={styles.title}>
              <Text size="300" weight="medium" color="grey1000" ellipsis>
                {title}
              </Text>
            </div>
          )}
          {years && (
            <div className={styles.description}>
              <Text.Normal>{!frenchCalendarFlag() && getNumberOfUnits()}</Text.Normal>
            </div>
          )}
        </div>
      </div>
    </ActionItem>
  )
}

export default observer(LeaveItem)
